import React from "react";
import classNames from "classnames";

interface FooterWithChildrenProps {
  children: React.ReactNode;
  className?: string;
}

const FooterWithChildren: React.FC<FooterWithChildrenProps> = React.memo(
  ({ children, className }) => {
    return (
      <footer
        className={classNames(
          "fixed bottom-0 left-0 right-0 z-10 bg-white flex flex-col justify-center items-center gap-[16px] w-full",
          className
        )}
        style={{
          boxShadow: "0px 4px 10px 4px rgba(0, 0, 0, 0.16)",
        }}
      >
        {children}
      </footer>
    );
  }
);

export default FooterWithChildren;
